import React, { useEffect, useState } from "react";
import { Layout, Typography, Avatar, Spin, Checkbox, Button, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";
import { BASE_URL } from "./config";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

const Web = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Options with links
  const slotOptions = [
    { value: "Zoom", url: "https://zoom.com" },
    { value: "Google Meet", url: "https://meet.google.com" },
    { value: "Webex-Cisco", url: "https://webex.com" },
    { value: "Microsoft Teams", url: "https://teams.microsoft.com" },
    { value: "Arattai", url: "https://www.arattai.in/" },
    { value: "Whatsapp", url: "https://www.whatsapp.com/?lang=en" },
    { value: "Others" },
    { value: "None of the above" }
  ];

  // Load user from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  // Fetch saved slots when user is available
  useEffect(() => {
    if (!user) return;

    setLoading(true);
    fetch(`${BASE_URL}/get_web.php?companyId=${user.company_id}`)
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "success" && Array.isArray(res.slots)) {
          setSelectedSlots(res.slots);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Fetch slots error:", err);
        setLoading(false);
      });
  }, [user]);

  // Handle checkbox changes
  const handleChange = (checkedValues) => {
    setSelectedSlots(checkedValues);
  };

  // Save slots to backend
  const handleSave = () => {
    if (!user) return message.error("User not found");

    setLoading(true);
    fetch(`${BASE_URL}/save_web.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        companyId: user.company_id,
        slots: selectedSlots,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.status === "success") {
          message.success("Slots saved successfully!");
        } else {
          message.error("Failed to save slots");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Save error:", err);
        message.error("Error saving slots");
        setLoading(false);
      });
  };

 return (
  <Layout style={{ minHeight: "100vh", fontFamily: "Poppins, sans-serif" }}>
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      breakpoint="lg"
      collapsedWidth="80"
    >
      <Sidebar collapsed={collapsed} user={user} />
    </Sider>

    <Layout>
      <HeaderBar title="Web Conference Preferences" />

      <Content
        style={{
          margin: window.innerWidth < 600 ? 12 : 24,
          paddingBottom: 40,
        }}
      >
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "70vh",
            }}
          >
            <Spin size="large" tip="Loading..." />
          </div>
        ) : (
          <div
            style={{
              border: "1px solid #ddd",
              borderRadius: 10,
              padding: window.innerWidth < 600 ? 16 : 24,
              background: "#fff",
              maxWidth: 700,
              margin: "0 auto",
            }}
          >
            <Title
              level={4}
              style={{ marginBottom: 20, textAlign: "center" }}
            >
              Choose Your Preferred Web Platforms
            </Title>

            {/* Checkbox list */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 14,
                fontSize: 15,
              }}
            >
              {slotOptions.map((opt) => (
                <Checkbox
                  key={opt.value}
                  value={opt.value}
                  checked={selectedSlots.includes(opt.value)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedSlots([...selectedSlots, opt.value]);
                    } else {
                      setSelectedSlots(
                        selectedSlots.filter((s) => s !== opt.value)
                      );
                    }
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    lineHeight: "1.4",
                    wordBreak: "break-word",
                  }}
                >
                  <span>{opt.value}</span>

                  {opt.url && (
                    <a
                      href={opt.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        fontSize: 13,
                        color: "#1677ff",
                        wordBreak: "break-all",
                      }}
                    >
                      ({opt.url})
                    </a>
                  )}
                </Checkbox>
              ))}
            </div>

            <Button
              type="primary"
              onClick={handleSave}
              style={{
                marginTop: 25,
                width: window.innerWidth < 600 ? "100%" : 180,
                height: 40,
                fontSize: 16,
              }}
              disabled={selectedSlots.length === 0}
            >
              Save
            </Button>
          </div>
        )}
      </Content>

      <Footer user={user} />
    </Layout>
  </Layout>
);

};

export default Web;
